import { TwitterWidget } from '../scripts/TwitterWidget';
import { TwitterStoryblok } from '../types/generated-storyblok';

interface ContentBlockProps {
  blok: TwitterStoryblok;
}

export const ContentBlockTweet = ({ blok }: ContentBlockProps) => (
  <div className="mx-auto w-full max-w-lg">
    <TwitterWidget url={blok.tweetUrl} />
  </div>
);
